module.exports = __webpack_public_path__ + "img/code.cbe8fc67.svg";